<template>
    <div>
        <h2 class="title">Aide</h2>

        <b-field class="file">
            <b-upload v-model="file" @input="charge">
                <a class="button is-warning">
                    <b-icon icon="upload"></b-icon>
                    <span>Charger un scenario</span>
                </a>
            </b-upload>
                <span class="file-name" v-if="file">
                {{ file.name }}
            </span>
        </b-field>
        <a href="https://fontawesome.com/icons?d=gallery&s=solid&m=free" target="_blank"><b-button type="is-info">Trouver des Icones</b-button></a>
        <p><b-button type="is-danger" @click="freshStart">EFFACE TOUT ET REPARTIR DE ZERO</b-button> </p>
        <h3 class="myh3">Usages</h3>
        <ul>
            <li><strong>Double clic : </strong>créer un élément</li>
            <li><strong>Molette : </strong>Zoom</li>
            <li><strong>Clic gauche sur élément: </strong>éditer un élément</li>
            <li><strong>Clic maintenu sur élément: </strong><br>déplacer un élément</li>
            <li><strong>Clic maintenu hors élément: </strong><br>déplacer le graphique</li>
        </ul>
        <h3 class="myh3">Fonctionnements</h3>
        <ul>
            <li>Les éléments d'édition apparaissent en zoomant un peu</li>
            <li>Pour changer de niveau, il faut zoomer sur un élément OU cliquer sur <img src="deeper.png"></li>
            <li>Créer un lien : déplacer une sortie vers l'entrée cible (rond jaune)</li>
        </ul>
      </div>
</template>

<script>
    export default {
        name: 'help',
        data (){
            return {
                file:null
            }
        },
        components: {},
        props: ['config'],
        computed: {


        },
        methods: {

            async freshStart(){
                await this.$mydb.do.clearAll()
                this.$emit("reload")
            },

            async charge(evt){
                await this.$mydb.do.upload(this.file)
                this.$emit("reload")
                //console.log(evt)
            }



        },
        mounted(){
            //console.log(this.config)
        }
    }


</script>


<style lang="scss" scoped>

    .myh3{
        font-size:2em;
        color:red;
    }
</style>